/* 130R — navegação do celular (agente navmobile, 18/10/2026).
   - Gaveta do menu: <dialog id="r130-gaveta"> em snippets/header-mobile-style.liquid; abre por qualquer [data-r130-gaveta-abrir].
     Painéis (raiz → submenu → sub-submenu) com Voltar e trilha; Esc e toque fora fecham; o fundo não rola.
   - Barra de baixo: sections/mobile-bar.liquid, que chega depois da página (?section_id=mobile-bar).
     Por isso tudo aqui é por delegação no document.
     · Carrinho: abre o carrinho do tema (evento "open-cart-drawer"); contador atualizado e anunciado (aria-live).
     · Meu carro: o clique é do modal da garagem ([data-r130-garagem-abrir]); aqui só o rótulo com o carro salvo (localStorage r130_garage).
     · WhatsApp: [data-r130-chassi-abrir] é do assets/r130-chassi.js. */
(function () {
  'use strict';
  var html = document.documentElement;
  var reduz = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var raizLoja = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function todos(sel, raiz) { return Array.prototype.slice.call((raiz || document).querySelectorAll(sel)); }
  function perto(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  /* =================== gaveta do menu =================== */
  var dlg = document.getElementById('r130-gaveta');
  var pilha = [];        // [{painel, botao}] do nível 1 em diante
  var abridor = null;
  var fechando = false;

  function raiz() { return document.getElementById('r130-gav-raiz'); }
  function atual() { return pilha.length ? pilha[pilha.length - 1].painel : raiz(); }
  function tituloDe(p) { return (p && p.getAttribute('data-r130-gav-titulo')) || 'Menu'; }

  function trilha() {
    var ol = dlg.querySelector('[data-r130-gav-trilha]');
    if (!ol) return;
    ol.textContent = '';
    ol.hidden = !pilha.length;
    if (!pilha.length) return;
    var niveis = [{ painel: raiz() }].concat(pilha);
    niveis.forEach(function (n, i) {
      var li = document.createElement('li');
      if (i === niveis.length - 1) {
        var s = document.createElement('span');
        s.textContent = tituloDe(n.painel);
        s.setAttribute('aria-current', 'location');
        li.appendChild(s);
      } else {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = tituloDe(n.painel);
        b.setAttribute('data-r130-gav-ir', String(i));
        li.appendChild(b);
      }
      ol.appendChild(li);
    });
  }

  function mostrar(alvo, sentido) {
    todos('.r130-gav__painel', dlg).forEach(function (p) {
      p.hidden = p !== alvo;
      p.classList.remove('r130-gav__painel--frente', 'r130-gav__painel--tras');
    });
    if (sentido && !reduz) {
      void alvo.offsetWidth; // reinicia a animação
      alvo.classList.add(sentido === 'frente' ? 'r130-gav__painel--frente' : 'r130-gav__painel--tras');
    }
    var titulo = document.getElementById('r130-gav-titulo');
    if (titulo) titulo.textContent = tituloDe(alvo);
    var voltar = dlg.querySelector('[data-r130-gav-voltar]');
    if (voltar) {
      voltar.hidden = !pilha.length;
      var pai = pilha.length ? document.getElementById(alvo.getAttribute('data-r130-gav-pai')) : null;
      voltar.setAttribute('aria-label', 'Voltar para ' + tituloDe(pai));
    }
    dlg.classList.toggle('r130-gav--sub', !!pilha.length);
    todos('[data-r130-gav-abre]', dlg).forEach(function (b) {
      var aberto = pilha.some(function (n) { return n.botao === b; });
      b.setAttribute('aria-expanded', aberto ? 'true' : 'false');
    });
    trilha();
    var corpo = dlg.querySelector('.r130-gav__corpo');
    if (corpo) corpo.scrollTop = 0;
  }

  function primeiroItem(p) { return p && p.querySelector('.r130-gav__item, a[href], button:not([hidden])'); }

  function entrar(botao) {
    var alvo = document.getElementById(botao.getAttribute('data-r130-gav-abre'));
    if (!alvo) return;
    pilha.push({ painel: alvo, botao: botao });
    mostrar(alvo, 'frente');
    var f = primeiroItem(alvo);
    if (f) f.focus({ preventScroll: true });
  }

  // Volta para o nível n (0 = raiz) e devolve o foco ao item que abriu o nível de baixo.
  function irPara(n) {
    if (n < 0 || n >= pilha.length) return;
    var botao = pilha[n].botao;
    pilha = pilha.slice(0, n);
    mostrar(atual(), 'tras');
    if (botao) botao.focus({ preventScroll: true });
  }

  function marcarAbridores(aberto) {
    todos('[data-r130-gaveta-abrir]').forEach(function (b) { b.setAttribute('aria-expanded', aberto ? 'true' : 'false'); });
  }

  function abrir(origem) {
    if (!dlg || dlg.open) return;
    abridor = origem || document.activeElement;
    pilha = [];
    mostrar(raiz());
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    html.classList.add('overflow-hidden', 'r130-gav-aberta');
    marcarAbridores(true);
    var f = primeiroItem(raiz());
    if (f) f.focus({ preventScroll: true });
    if (reduz) dlg.classList.add('is-aberta');
    else requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-aberta'); }); });
  }

  function limpar() {
    fechando = false;
    dlg.classList.remove('is-aberta');
    html.classList.remove('overflow-hidden', 'r130-gav-aberta');
    marcarAbridores(false);
  }

  function fechar(imediato) {
    if (!dlg || !dlg.open || fechando) return;
    fechando = true;
    dlg.classList.remove('is-aberta');
    var fim = function () {
      if (dlg.open) {
        if (typeof dlg.close === 'function') dlg.close(); else { dlg.removeAttribute('open'); dlg.dispatchEvent(new Event('close')); }
      }
      fechando = false;
    };
    if (imediato || reduz) fim(); else setTimeout(fim, 230);
  }

  if (dlg) {
    dlg.addEventListener('close', function () {
      limpar();
      var a = abridor;
      abridor = null;
      if (a && a.focus && document.contains(a)) a.focus({ preventScroll: true });
    });
    // Esc: fecha com a mesma animação
    dlg.addEventListener('cancel', function (ev) { ev.preventDefault(); fechar(); });
    // Foco preso: o Tab dá a volta dentro da gaveta (não escapa para a página nem para a barra do navegador).
    dlg.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Tab') return;
      var focaveis = todos('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])', dlg).filter(function (el) {
        return !el.disabled && !el.closest('[hidden]') && el.getClientRects().length;
      });
      if (!focaveis.length) return;
      var primeiro = focaveis[0], ultimo = focaveis[focaveis.length - 1];
      var ativo = document.activeElement;
      if (ev.shiftKey && (ativo === primeiro || !dlg.contains(ativo) || ativo === dlg || ativo.id === 'r130-gav-titulo')) { ev.preventDefault(); ultimo.focus(); }
      else if (!ev.shiftKey && (ativo === ultimo || !dlg.contains(ativo))) { ev.preventDefault(); primeiro.focus(); }
    });
    dlg.addEventListener('click', function (ev) {
      if (ev.target === dlg) { fechar(); return; } // toque no fundo escuro
      var t = perto(ev.target, 'button, a');
      if (!t || !dlg.contains(t)) return;
      if (t.hasAttribute('data-r130-gav-abre')) { ev.preventDefault(); entrar(t); }
      else if (t.hasAttribute('data-r130-gav-voltar')) { irPara(pilha.length - 1); }
      else if (t.hasAttribute('data-r130-gav-ir')) { irPara(parseInt(t.getAttribute('data-r130-gav-ir'), 10) || 0); }
      else if (t.hasAttribute('data-r130-gav-fechar')) { fechar(); }
    });
    // Voltando pelo botão "voltar" do navegador (cache da página), a gaveta não pode aparecer aberta.
    window.addEventListener('pageshow', function (ev) { if (ev.persisted && dlg.open) fechar(true); });
    // Passou para a tela de computador com a gaveta aberta: fecha.
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 992px)');
      var aoMudar = function (e) { if (e.matches) fechar(true); };
      if (mq.addEventListener) mq.addEventListener('change', aoMudar); else if (mq.addListener) mq.addListener(aoMudar);
    }
  }

  document.addEventListener('click', function (ev) {
    var b = perto(ev.target, '[data-r130-gaveta-abrir]');
    if (!b || !dlg) return;
    ev.preventDefault();
    if (dlg.open) fechar(); else abrir(b);
  });

  /* =================== barra de baixo =================== */
  function itens(n) { return n === 1 ? '1 item' : n + ' itens'; }
  var ultimaQtd = null;

  function aplicarQtd(n, anunciar) {
    todos('[data-r130-mbar-qtd]').forEach(function (b) {
      if (b.textContent.trim() !== String(n)) b.textContent = String(n);
      if (n > 0) b.removeAttribute('data-vazio'); else b.setAttribute('data-vazio', '');
    });
    todos('[data-r130-mbar-qtd-sr]').forEach(function (s) { s.textContent = ', ' + itens(n); });
    if (anunciar) {
      var aviso = document.querySelector('[data-r130-mbar-aviso]');
      if (aviso) aviso.textContent = 'Carrinho atualizado: ' + itens(n);
    }
    ultimaQtd = n;
  }

  // O tema escreve o total direto no contador (classe js-cart-items-count): acompanha e anuncia.
  var observador = window.MutationObserver ? new MutationObserver(function (lista) {
    var alvo = lista[0] && (lista[0].target.nodeType === 1 ? lista[0].target : lista[0].target.parentNode);
    var b = perto(alvo, '[data-r130-mbar-qtd]');
    if (!b) return;
    var n = parseInt(b.textContent, 10);
    if (isNaN(n) || n === ultimaQtd) return;
    aplicarQtd(n, ultimaQtd !== null);
  }) : null;

  var fetchOriginal = window.fetch;
  function lerCarrinho() {
    if (!fetchOriginal) return;
    fetchOriginal.call(window, raizLoja + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = (c && c.item_count) | 0;
        aplicarQtd(n, ultimaQtd !== null && n !== ultimaQtd);
      })
      .catch(function () {});
  }
  var lerDepois = (function () {
    var t = null;
    return function () { clearTimeout(t); t = setTimeout(lerCarrinho, 120); };
  })();

  // Qualquer código (tema, gaveta nova do carrinho, apps) que mexa no carrinho por fetch atualiza o contador.
  if (fetchOriginal) {
    window.fetch = function (entrada) {
      var p = fetchOriginal.apply(this, arguments);
      try {
        var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) p.then(lerDepois, function () {});
      } catch (e) {}
      return p;
    };
  }
  ['product-added', 'cart-change', 'cart:updated', 'cart:refresh'].forEach(function (nome) { document.addEventListener(nome, lerDepois); });

  document.addEventListener('click', function (ev) {
    var a = perto(ev.target, '[data-r130-mbar-carrinho]');
    if (!a) return;
    var barra = perto(a, '[data-r130-carrinho-tipo]');
    var tipo = barra ? barra.getAttribute('data-r130-carrinho-tipo') : '';
    var modelo = document.body.getAttribute('data-template') || '';
    if (tipo === 'page' || tipo === 'catalog' || modelo === 'cart') return; // segue o link para /cart
    ev.preventDefault();
    document.dispatchEvent(new CustomEvent('open-cart-drawer'));
  });

  /* ---- Meu carro: rótulo com o carro salvo ----
     Mesmo texto do botão "Meu carro" do computador (snippets/130r-garagem-virtual.liquid, [data-r130-garagem-rotulo]):
     "HB20 2019", "ix35 2015"; sem ano, "Hyundai HB20". A barra chega depois da página, por isso preenche aqui também. */
  function carroSalvo() {
    try {
      var c = JSON.parse(localStorage.getItem('r130_garage') || 'null');
      return c && c.brand && c.model ? c : null;
    } catch (e) { return null; }
  }
  function nomeModelo(nome) {
    return String(nome || '').split(' ').map(function (p) {
      if (/\d/.test(p)) return /^I[X]?\d/.test(p) ? p.toLowerCase() : p;
      if (/^[B-DF-HJ-NP-TV-Z]{1,2}$/.test(p)) return p;
      return p.split('-').map(function (q) { return q.charAt(0).toUpperCase() + q.slice(1).toLowerCase(); }).join('-');
    }).join(' ');
  }
  function nomeMarca(s) {
    return String(s || '').split(' ').map(function (w) {
      if (/\d/.test(w) || ['BMW', 'VW', 'GM'].indexOf(w.toUpperCase()) !== -1) return w.toUpperCase();
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    }).join(' ');
  }
  function rotuloCarro(c) {
    if (!c) return '';
    var m = nomeModelo(c.model);
    return c.year ? m + ' ' + c.year : nomeMarca(c.brand) + ' ' + m;
  }
  var ultimoCarro = '-';
  function atualizarCarro() {
    var c = carroSalvo();
    var nome = rotuloCarro(c);
    if (nome === ultimoCarro && !document.querySelector('[data-r130-mbar-carro]:not([data-r130-mbar-pronto])')) return;
    ultimoCarro = nome;
    todos('[data-r130-mbar-carro]').forEach(function (b) {
      b.setAttribute('data-r130-mbar-pronto', '');
      var rot = b.querySelector('[data-r130-mbar-carro-rot]');
      if (rot) rot.textContent = nome || 'Meu carro';
      b.classList.toggle('is-salvo', !!nome);
      b.setAttribute('aria-label', nome ? 'Meu carro: ' + nome + '. Trocar o carro' : 'Meu carro: escolher o carro');
    });
  }
  var carroDepois = (function () {
    var t = null;
    return function () { clearTimeout(t); t = setTimeout(atualizarCarro, 250); };
  })();
  // O carro é salvo por outros scripts (modal da garagem, seletor da home): confere depois de cada toque ou escolha.
  document.addEventListener('click', carroDepois, true);
  document.addEventListener('change', carroDepois, true);
  window.addEventListener('storage', function (ev) { if (!ev.key || ev.key === 'r130_garage') atualizarCarro(); });
  ['r130:garagem', 'r130-garagem', 'r130:garage-changed', 'r130:carro'].forEach(function (nome) { document.addEventListener(nome, atualizarCarro); });

  /* ---- barra pronta (ela chega depois, por lazysizes) ---- */
  function prepararBarra() {
    var barra = document.getElementById('mobile-bar');
    if (!barra || barra.hasAttribute('data-r130-pronta')) return;
    barra.setAttribute('data-r130-pronta', '');
    var b = barra.querySelector('[data-r130-mbar-qtd]');
    if (b) {
      var n = parseInt(b.textContent, 10);
      aplicarQtd(isNaN(n) ? 0 : n, false);
      if (observador) observador.observe(b, { childList: true, characterData: true, subtree: true });
    }
    if ((document.body.getAttribute('data-template') || '') === 'cart') {
      var c = barra.querySelector('[data-r130-mbar-carrinho]');
      if (c) c.setAttribute('aria-current', 'page');
    }
    marcarAbridores(!!(dlg && dlg.open));
    ultimoCarro = '-';
    atualizarCarro();
  }
  document.addEventListener('lazyincluded', function () { prepararBarra(); });
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) lerCarrinho(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepararBarra);
  else prepararBarra();
})();
